'use strict';

exports.__esModule = true;

var _env = require('../env');

/**
 * Local storage wrapper (for tests mainly)
 */
exports.default = {
  getItem: function getItem(key) {
    try {
      return (0, _env.env)().localStorage && (0, _env.env)().localStorage.getItem(key);
    } catch (e) {}
  },
  setItem: function setItem(key, value) {
    try {
      return (0, _env.env)().localStorage && (0, _env.env)().localStorage.setItem(key, value);
    } catch (e) {}
  }
};